"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _MaterialComponent = _interopRequireDefault(require("../MaterialComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @prop mini = false
 * @prop plain = false
 */
class Formfield extends _MaterialComponent.default {
  constructor() {
    super();
    this.componentName = 'form-field';
    this._mdcProps = ['align-end'];
  }

}

exports.default = Formfield;


// WEBPACK FOOTER //
// ../node_modules/preact-material-components/FormField/index.js